import moment from 'moment'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

import { useSchedule } from 'modules/shift_management/hooks/useSchedule'

type DaysByEmployee = Record<string, string[]>

const weekDays = Object.freeze({
  0: 'sunday',
  1: 'monday',
  2: 'tuesday',
  3: 'wednesday',
  4: 'thursday',
  5: 'friday',
  6: 'saturday',
})

const getDates = (start: string, end: string): string[] => {
  const currentDate = moment(start)
  const endDate = moment(end)
  const dateArray = [start]
  while (currentDate < endDate) {
    dateArray.push(currentDate.add(1, 'days').format('YYYY-MM-DD'))
  }
  return dateArray
}

export const getWeekDay = (date: string): string => {
  return weekDays[moment(date).day() as keyof typeof weekDays]
}

const useDateRangeSelection = (
  allEmployees: boolean,
  employeeIds: number[],
  start: string,
  end: string,
  days: string,
  fromUnassignedShift?: boolean,
  date?: moment.Moment
): DaysByEmployee => {
  const [{ view }] = useSchedule()

  const daysByEmployee = useUnsafeMemo(() => {
    const daysSplitted: string[] | undefined = days?.split(',')
    const range = getDates(start, end)

    const dateRange: string[] = daysSplitted?.length
      ? range.filter((day) =>
          daysSplitted?.includes(weekDays[moment(day).day() as keyof typeof weekDays])
        )
      : range

    const finalRange = fromUnassignedShift || (!!date && view.isByAreas) ? range : dateRange

    if (allEmployees) return { ['all']: finalRange }

    return employeeIds?.reduce((acc: DaysByEmployee, id: number) => {
      acc[id] = finalRange
      return acc
    }, {})
  }, [employeeIds, start, end, days, fromUnassignedShift, date, view.isByAreas])

  return daysByEmployee
}

export default useDateRangeSelection
